__turbopack_context__.v({
  "className": "source_serif_4_5ec3c69d-module__RO1UgG__className",
  "variable": "source_serif_4_5ec3c69d-module__RO1UgG__variable",
});
